//* BE 안내(3): 앞뒤 공백을 뺀 값이 숫자만일 때만 금액이다 — `20,000`처럼 쉼표가 있으면 문구로 본다
export const parseRewardAmount = (rewardProductName?: string | null) => {
  const trimmed = rewardProductName?.trim();

  return trimmed && /^\d+$/.test(trimmed) ? Number(trimmed) : null;
};

export const formatRewardTotal = (
  rewardProductNames: (string | null | undefined)[],
) => {
  const amounts = rewardProductNames.map(parseRewardAmount);
  const total = amounts.reduce<number>((sum, amount) => sum + (amount ?? 0), 0);

  if (total === 0) {
    return null;
  }

  const hasText = rewardProductNames.some(
    (name, index) => !!name?.trim() && amounts[index] === null,
  );

  return `최대 ${total.toLocaleString('ko-KR')}원${hasText ? '+' : ''}`;
};
